import { lazy } from "react";
import { MODULE_IDS } from "../../constants/enums";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { app_navbar_routes } from "../../constants/app-navbar-routes";

const GoodsReceivedNoteTable = Loadable(
  lazy(() =>
    import("./GoodsReceivedNoteTable").then(({ GoodsReceivedNoteTable }) => ({
      default: GoodsReceivedNoteTable,
    })),
  ),
);

const ManageSingleGoodsReceivedNote = Loadable(
  lazy(() =>
    import("./ManageSingleGoodsReceivedNote").then(
      ({ ManageSingleGoodsReceivedNote }) => ({
        default: ManageSingleGoodsReceivedNote,
      }),
    ),
  ),
);

export const grnRoutes = [
  {
    path: app_navbar_routes.app.grn.grn,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[MODULE_IDS.GRN]}>
        <GoodsReceivedNoteTable />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${app_navbar_routes.app.grn.grn}/manage`,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[MODULE_IDS.GRN]}>
        <ManageSingleGoodsReceivedNote />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${app_navbar_routes.app.grn.grn}/manage/:uuid`,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[MODULE_IDS.GRN]}>
        <ManageSingleGoodsReceivedNote />
      </AuthorizedRoute>
    ),
  },
];
